import axiosInstance from "../helpers/axiosInstance";

export const getVendorApi = async (item) => {
    const response = await axiosInstance.get("staff/vendors", {
        params:{ 
            page:0,
            size:30,
            searchKey: item.searchKey
         }
    });
    return response.data;
};

export const getVendorByIdApi = async (vendorId) => {
    const url = `staff/vendor/${vendorId}`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const createVendorApi = async (request) => {
    const url = `staff/vendors`;
    const response = await axiosInstance.post(url, request.formData);
    return response.data;
};

export const updateVendorApi = async (request) => {
    const url = `staff/vendors`;
    const response = await axiosInstance.put(url, request.formData);
    return response.data;
};

export const getVendorSecondaryMailsApi = async (id) => {
    const url = `staff/vendorSecondaryEmail/${id}`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const createVendorSecondaryEmailApi = async (request) => {
    const url = `staff/vendorSecondaryEmail`;
    const response = await axiosInstance.post(url, request.formData);
    return response.data;
};

export const updateVendorSecondaryEmailApi = async (request) => {
    const url = `staff/vendorSecondaryEmail`;
    const response = await axiosInstance.put(url, request.formData);
    return response.data;
};
